module.exports = __webpack_public_path__ + "img/info2.641154d7.png";